import {faBars} from "@fortawesome/pro-solid-svg-icons/faBars";
import {faBomb} from "@fortawesome/pro-solid-svg-icons/faBomb";
import {faCaretDown} from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import {faRectangleHistory} from "@fortawesome/pro-solid-svg-icons/faRectangleHistory";
import {faXmark} from "@fortawesome/pro-solid-svg-icons/faXmark";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {GetItemCounts, SendsPageItemType, useAccountUser, useInfiniteShortListSendsPage} from "@twigsby/client-data";
import {
    ContentBlock,
    FilterInput,
    FlexAlign,
    FlexGap,
    FlexJustify,
    InfiniteLoadTrigger,
    StackHorizontal,
    StackVertical,
    useComboBoxKeyboardNavigation,
    useFilter,
    useLayout,
    useOutsiderDetector
} from "@twigsby/frontend-framework";
import React, {useEffect, useRef, useState} from "react";
import {NavLink, useNavigate, useParams} from "react-router-dom";

type StandaloneSendTemplateNavigationType = {
    containerRef?: any;
}

const StandaloneSendTemplateNavigation = (props: StandaloneSendTemplateNavigationType) => {
    const navigate = useNavigate();

    const { data: userData } = useAccountUser();

    const [ userPageCount, setUserPageCount ] = useState<number>(0);
    const [ sectionOpen, setSectionOpen ] = useState<boolean>(false);

    const { pageId } = useParams();
    const { isLarge } = useLayout();

    const filterRef: any = useRef<HTMLInputElement>(null);
    const menuRef: any = useRef(null);
    const menuTriggerRef: any = useRef(null);
    useOutsiderDetector(menuRef, () => sectionOpen ? setSectionOpen(false) : null);

    const [ itemCounts, setItemCounts ] = useState<any>({ loaded: 0, total: 0 } );

    const {
        status,
        data,
        error,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage
    } = useInfiniteShortListSendsPage();

    const { filterItems, filterValue, FilterData, ResetFilter } = useFilter({ filterData: data, filterKey: 'title'});
    const { HandleInputEscape }  = useComboBoxKeyboardNavigation({ itemClassName: '', itemContainerSelector: null, resetCallback: ResetFilter });

    useEffect(() => {
        CheckPageActive();
        CountValidUserPages();
        if(data) {
            setItemCounts(GetItemCounts(data as any));
        }
    }, [pageId, data]);

    const CountValidUserPages = () => {
        if(data) {
            let count = 0;

            data.pages.map((group: any, groupIndex: number) =>
                group.data.map((pageEntry: SendsPageItemType, index: number) => {
                    if (!pageEntry.isActive || pageEntry.isDeleted) return null;
                    count++;
                })
            );

            setUserPageCount(count);
        }
    }

    const CheckPageActive = () => {
        if(!pageId && data && data?.pages[0].totalRecords > 0 &&
            !userData?.roles.includes('SENDS_PAGE_ADMIN') && !userData?.roles.includes('MANAGER')) {
            navigate(`/sends-page/${data.pages[0].data[0].id}`);
        }
    }

    if(!pageId) return <></>;

    return (
        <nav className={`section-navigation section-navigation-rounded ${sectionOpen ? 'open' : ''}`} ref={menuRef} >
            <div className={`section-navigation-header ${!isLarge ? 'mb-sm' : ''}`}>
                <div className={`section-navigation-title`} onClick={() => setSectionOpen(!sectionOpen)} ref={menuTriggerRef}>
                    <FontAwesomeIcon icon={sectionOpen ? faXmark : faBars} style={{ marginInlineEnd: '.75em' }} fixedWidth={true} />
                    <h6 className={'m-0 sub-heading'}>Your Pages {!isLarge && (<>({userPageCount})</>)}</h6>
                    <FontAwesomeIcon icon={faCaretDown} style={{ marginInlineStart: 'auto' }} fixedWidth={true} />
                </div>
            </div>

            <div className={`section-navigation-entries`} style={{ paddingTop: !isLarge ? `${menuTriggerRef.current?.offsetHeight}px` : 0 }}>
                {status === "loading" ? (
                    <div className={'content-loader content-fader'}>
                        <div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }}/>
                        <div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }}/>
                        <div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }}/>
                        <div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }}/>
                        <div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }}/>
                        <div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }}/>
                        <div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }}/>
                        <div style={{ height: '3em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }}/>
                    </div>
                ) : status === "error" ? (
                    <ContentBlock error={true} title={error.name} content={error.message} />
                ) : (
                    <StackVertical gap={FlexGap.ExtraSmall}>
                        {itemCounts.total > 14 && (
                            <div className={`pt-sm pl-sm pr-sm`}>
                                <FilterInput
                                    placeholder={'Filter...'}
                                    inputRef={filterRef}
                                    filterValue={filterValue}
                                    active={true}
                                    loading={false}
                                    resetCallback={() => ResetFilter()}
                                    onBlur={(e: any) => console.log('blur', e)}
                                    onChange={(e: any) => FilterData(e)}
                                    onKeyDown={(e: any) => HandleInputEscape(e)}
                                    onFocus={(e: any) => console.log('filterFocusCallback', e)}
                                />
                            </div>
                        )}

                        {filterItems && filterItems.map((pageEntry: SendsPageItemType, index: number) => {
                            return (
                                <NavLink
                                    to={`/sends-page/${pageEntry.id}`}
                                    key={`pageEntry${index}`}
                                    onClick={() => {
                                        setSectionOpen(false);
                                    }}
                                    className={({isActive}) => `page-list-nav-item ${isActive ? 'page-list-nav-item-active' : ''} ${!isLarge ? 'm-0' : ''}`}
                                >
                                    {pageEntry.title}
                                </NavLink>
                            )}
                        )}

                        {filterItems.length === 0 && itemCounts.total > 0 && (
                            <StackVertical gap={FlexGap.ExtraSmall} align={FlexAlign.Center} justify={FlexJustify.Center} extraClass={'feature-highlight p-lg  text-center'}>
                                <FontAwesomeIcon icon={faRectangleHistory} size={"2x"} />
                                <h6 className={'sub-heading mt-sm mb-xs'}>No Matching Pages</h6>
                            </StackVertical>
                        )}

                        {itemCounts.total === 0 && (
                            <StackVertical gap={FlexGap.ExtraSmall} align={FlexAlign.Center} justify={FlexJustify.Center} extraClass={'feature-highlight p-lg  text-center'}>
                                <FontAwesomeIcon icon={faBomb} size={"2x"} />
                                <h6 className={'sub-heading mt-sm mb-xs'}>No Pages Exist</h6>
                            </StackVertical>
                        )}

                        {itemCounts.total > 0 && filterItems.length < itemCounts.total && (
                            <InfiniteLoadTrigger
                                loaded={itemCounts.loaded}
                                totalCount={itemCounts.total}
                                hasNextPage={hasNextPage}
                                fetchNextPage={fetchNextPage}
                                isFetchingNextPage={isFetchingNextPage}
                                extraClass={'faded small'}
                                hideLabel={true}
                            />
                        )}

                    </StackVertical>
                )}
            </div>
        </nav>
    )
}

export default StandaloneSendTemplateNavigation
